import { useState } from 'react'

import { Box, Button, Heading, Tag, Text } from '@grupoboticario/flora-react'
import { CameraIcon, StarFillIcon, StarOutlineIcon } from '@grupoboticario/flora-react-icons'

import { useCart } from 'src/hooks/useCart'
import { IProduct } from 'src/@interfaces'

import {
  ProductCardAction,
  ProductCardContent,
  ProductCardImage,
  ProductCardImageWrapper,
  ProductCardWrapper,
} from './ProductCard.style'

const realFormat = Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

const MAX_RATING_STARS = 5

export interface ProductCardProps {
  product: IProduct
}

export const ProductCard = ({ product }: ProductCardProps) => {
  const [isImageDefault, setImageDefault] = useState(false)
  const { addToCart, isLoading } = useCart()

  const addProductToCart = async () => {
    await addToCart([product])
  }

  const onErrorImage = () => {
    setImageDefault(true)
  }

  return (
    <ProductCardWrapper>
      <ProductCardImageWrapper>
        <ProductCardImage
          align="center"
          justify="center"
        >
          {isImageDefault ? (
            <CameraIcon
              color="$nonInteractiveAltAuxiliar"
              aria-label="Produto sem imagem"
            />
          ) : (
            <img
              src={product.images[0]}
              alt={product.name}
              width={40}
              height={40}
              onError={onErrorImage}
            />
          )}
        </ProductCardImage>
        <Text
          size="exceptionsAuxiliarRegular"
          color="$nonInteractivePredominant"
        >
          {product.sku}
        </Text>
      </ProductCardImageWrapper>
      <ProductCardContent>
        <Text
          size="bodyMediumShort"
          color="$nonInteractivePredominant"
          as="p"
          css={{ marginBottom: '$1' }}
          weight="medium"
        >
          {product.name}
        </Text>

        <Box>
          {[...Array(MAX_RATING_STARS)].map((_, index) =>
            product.rating.ratingValue >= index + 1 ? (
              <StarFillIcon
                key={`rating-${product.sku}-${index}`}
                aria-label="nota positiva"
                size={12}
                color="$backgroundAltPrimary"
              />
            ) : (
              <StarOutlineIcon
                key={`rating-${product.sku}-${index}`}
                aria-label="nota neutra"
                size={12}
                color="$backgroundAltPrimary"
              />
            ),
          )}
        </Box>

        <Box
          css={{
            marginBottom: '$1',
          }}
        >
          {product.tags?.map((tag) => (
            <Tag
              size="small"
              key={tag}
              shape="ghost"
              css={{ marginRight: '$2' }}
            >
              {tag}
            </Tag>
          ))}
        </Box>

        <Heading
          as="p"
          level={6}
          color="$nonInteractivePredominant"
          css={{ fontWeight: '$medium' }}
        >
          {realFormat.format(product.salePrice)}
        </Heading>
      </ProductCardContent>
      <ProductCardAction
        align="center"
        justify="flex-end"
      >
        {product.availability.available ? (
          <Button
            size="small"
            variant="standard"
            onClick={addProductToCart}
            isLoading={isLoading}
            aria-label={`Adicionar ${product.name} à sacola`}
            autotagging-flora="on"
          >
            Adicionar
          </Button>
        ) : (
          <Button
            size="small"
            disabled
          >
            Indisponível
          </Button>
        )}
      </ProductCardAction>
    </ProductCardWrapper>
  )
}
